import { useContext, useMemo } from 'react';
import NodeContext from '../../../services/Context/NodeContext';
import ModelType from '../../Model/ModelType';
import T from '../../../localization/LocalizationKeys';
import _ from 'lodash';
import { useUpdatedNodes } from 'utils/hooks/useUpdatedNodes';

const NodeDataSource = ({ nodes }) => {
  const nodeContext = useContext(NodeContext);

  const { nodes: newNodes, isLoading } = useUpdatedNodes(nodes);

  return useMemo(() => {
    if (nodes != null && nodes.length !== 0) {
      return { nodes: newNodes, isLoading };
    }
    return { nodes: _.compact([nodeContext?.node]), isLoading: false };
  }, [nodes, nodeContext?.node, newNodes, isLoading]);
};

NodeDataSource.models = [
  {
    path: 'nodes',
    type: ModelType.NODE_SELECTION,
    label: T.common.input.nodes.title
  }
];

NodeDataSource.getUsedAssets = (data) => {
  if (data.nodes) {
    return { static: data.nodes, isDynamic: false };
  }
  return { static: [], isDynamic: true };
};

export default NodeDataSource;
